import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    brand: "Maqam",
    tagline: "Apply to 100 jobs. In one click.",
    hero_sub: "Smart job discovery and bulk applications. Built for Saudi Arabia.",
    get_started: "Get Started Free",
    see_how: "See how it works",
    login: "Login",
    sign_up: "Sign Up",
    dashboard: "Dashboard",
    search: "Search Engine",
    applications: "Applications",
    inbox: "Inbox",
    profile: "Profile",
    settings: "Settings",
    cv_review: "CV Review",
    cv_builder: "CV Builder",
    certificates: "Certificates",
    skills: "Skills (comma separated)",
    skills_nav: "Skills",
    interview: "Interview Coach",
    mock_interview: "Mock Interview · Marcus",
    alerts: "Job Alerts",
    weekly_brief: "Weekly Brief",
    salary: "Salary Intel",
    billing: "Billing",
    deal_closer: "Deal Closer",
    career_gps: "Career GPS",
    hrdf: "HRDF Benefits",
    privacy_nav: "Privacy",
    admin: "Admin",
    referral: "Referrals",
    logout: "Log out",
    job_role: "Job role or keyword",
    cities: "Cities",
    search_btn: "Search",
    select_all: "Select all",
    apply_bulk: "Apply to all in one click",
    consent_title: "Consent before sending",
    consent_body: "You agree that Maqam may use your profile, CV and personal data to send tailored applications on your behalf to the selected employers. You can revoke consent anytime.",
    i_consent: "I consent",
    cancel: "Cancel",
    total_apps: "Total applications",
    sent: "Sent",
    viewed: "Viewed",
    responded: "Responded",
    rejected: "Rejected",
    unread: "Unread messages",
    welcome_back: "Welcome back",
    quick_search: "Quick search",
    recent_apps: "Recent applications",
    view_all: "View all",
    no_data: "No data yet",
    full_name: "Full name",
    email: "Email",
    password: "Password",
    consent_register: "I agree to the Privacy Policy and consent to automated CV submission on my behalf.",
    your_platform_email: "Your Maqam inbox email",
    cv_text: "CV text (paste full CV)",
    skills: "Skills (comma separated)",
    job_titles: "Target job titles (comma separated)",
    preferred_cities: "Preferred cities (comma separated)",
    experience: "Years of experience",
    save: "Save",
    saved: "Saved",
    language: "Language",
    pricing_title: "Simple pricing",
    pricing_sub: "Free to start. Upgrade when you need more firepower.",
  },
  ar: {
    brand: "مقام",
    tagline: "قدّم على 100 وظيفة. بنقرة واحدة.",
    hero_sub: "اكتشف الوظائف بذكاء اصطناعي وقدّم عليها دفعة واحدة — مصمم للسوق السعودي.",
    get_started: "ابدأ مجاناً",
    see_how: "شاهد كيف يعمل",
    login: "تسجيل الدخول",
    sign_up: "إنشاء حساب",
    dashboard: "لوحة التحكم",
    search: "محرك البحث",
    applications: "طلباتي",
    inbox: "البريد",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    cv_review: "مراجعة السيرة",
    cv_builder: "إنشاء السيرة",
    certificates: "الشهادات والدورات",
    skills: "المهارات",
    skills_nav: "الشهادات",
    interview: "مدرب المقابلات",
    mock_interview: "محاكاة المقابلة · ماركوس",
    alerts: "تنبيهات الوظائف",
    weekly_brief: "النشرة الأسبوعية",
    salary: "معلومات الرواتب",
    billing: "الفوترة",
    deal_closer: "إبرام الصفقة",
    career_gps: "بوصلة المسيرة",
    hrdf: "صندوق الموارد البشرية",
    privacy_nav: "الخصوصية",
    admin: "الإدارة",
    referral: "الإحالات",
    logout: "تسجيل الخروج",
    job_role: "المسمى الوظيفي أو كلمة مفتاحية",
    cities: "المدن",
    search_btn: "ابحث بالذكاء الاصطناعي",
    select_all: "تحديد الكل",
    apply_bulk: "قدّم على الكل بنقرة",
    consent_title: "موافقة قبل الإرسال",
    consent_body: "توافق على أن تستخدم مقام ملفك الشخصي وسيرتك الذاتية لإرسال طلبات مخصصة نيابةً عنك.",
    i_consent: "أوافق",
    cancel: "إلغاء",
    total_apps: "إجمالي الطلبات",
    sent: "تم الإرسال",
    viewed: "تمت المشاهدة",
    responded: "رد",
    rejected: "مرفوض",
    unread: "رسائل غير مقروءة",
    welcome_back: "مرحباً بعودتك",
    quick_search: "بحث سريع",
    recent_apps: "آخر الطلبات",
    view_all: "عرض الكل",
    no_data: "لا توجد بيانات بعد",
    full_name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    consent_register: "أوافق على سياسة الخصوصية والتقديم التلقائي نيابةً عني.",
    your_platform_email: "بريد مقام الخاص بك",
    cv_text: "نص السيرة الذاتية",
    skills: "المهارات",
    job_titles: "الوظائف المستهدفة",
    preferred_cities: "المدن المفضلة",
    experience: "سنوات الخبرة",
    save: "حفظ",
    saved: "تم الحفظ",
    language: "اللغة",
    pricing_title: "أسعار بسيطة",
    pricing_sub: "ابدأ مجاناً وارقِ لخطة متقدمة عند الحاجة.",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("jf_lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("jf_lang", lang);
  }, [lang]);

  const t = (k) => dict[lang][k] ?? k;
  const toggle = () => setLang((l) => (l === "en" ? "ar" : "en"));

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
